<template>
  <div
    class="product-detailed-page"
    id="PRODUCT_DETAILS"
  >
    <product-page-pagination
      :prev-product="productDetails.product.prevProduct ? productDetails.product.prevProduct : null"
      :next-product="productDetails.product.nextProduct ? productDetails.product.nextProduct : null"
      :prev-product-message="$t('ads.main.previous')"
      :next-product-message="$t('ads.main.next')"
    />
    <div class="product-detailed-page__top">
      <div class="product-detailed-page__gallery">
        <product-page-brand
          v-if="productBrandImage"
          :product-logo-image="productBrandImage"
          :product-logo-image-src="productBrandImage.brandImage.src"
          :product-logo-name="productBrandImage.brandName"
          :product-brand-link="productDetails.product.brand.link"
        />
        <product-gallery
          v-if="productDetails.images.length"
          :product-name="productDetails.product.name"
          :product-videos="videos"
        />
        <photo-swipe-gallery
          id="pdpImagesFullScreen"
          :product-name="productDetails.product.name"
        />
        <product-flags
          v-if="productFlags.length"
          :product-flags="productFlags"
        />
      </div>
      <div class="product-detailed-page__sale-box">
        <sale-box />
      </div>
    </div>

    <slot name="maintainedProductPage" />
    <slot name="globaleContentAds" />

    <div
      class="product-detailed-page__details"
      id="product-details"
    >
      <product-navigation
        :navigation-items="navigationItems"
        :id="possibleAlternatives.length ? 'alternative' : ''"
        @click="productNavigationClickHandler"
      />
      <div
        v-if="possibleAlternatives.length"
        class="product-detailed-page__carousel"
      >
        <recommendations-teaser
          :headline="$t('global.possible_alternatives')"
          :show-headline-desktop="false"
          :initial-products="possibleAlternatives"
        />
      </div>

      <section
        class="product-detailed-page__section"
        id="details-and-features"
        v-if="qualityKeys.length || longDescription"
      >
        <accordion
          ref="accordion"
          class="product-description__accordion"
          :is-content-html="true"
          id="details-and-features"
          :initial-open="true"
          :name="navigationItems[navigationItems.length - 1].name"
        >
          <div class="product-description__content | html-teaser">
            <product-description
              id="details-and-features"
              ref="details-and-features-accordion"
              :description="longDescription"
              :quality-keys="qualityKeys"
            />
            <div
              class="product-detailed-page__selling-points"
              v-if="listSellingPoints"
            >
              <ul class="selling-points">
                <li
                  class="selling-point"
                  v-for="(sellingPoint, index) in listSellingPoints"
                  :key="`sellingIndex${productDetails.product.itemId}_${index}`"
                >
                  {{ sellingPoint }}
                </li>
              </ul>
            </div>
            <div
              class="product-detailed-page__features"
              v-if="productDetails.features.length"
            >
              <product-features />
            </div>
          </div>
        </accordion>
      </section>

      <section
        class="product-detailed-page__section"
        v-if="productDetails.product.brand && productDetails.product.brand.htmlText"
        id="brand"
      >
        <product-seobrand
          ref="brand-accordion"
        />
      </section>
    </div>

    <div
      v-if="lastSeenItems.length"
      class="product-detailed-page__carousel"
    >
      <recommendations-teaser
        :headline="$t('ads.main.recommendation.lastSeen.headline')"
        :initial-products="lastSeenItems"
      />
    </div>

    <section
      class="product-detailed-page__section product-detailed-page__accordion-padding"
      id="productSafetyInformation"
      v-if="productSafetyInformationHasData"
    >
      <product-safety-information-accordion
        ref="product-safety-information-accordion"
        :product-safety-information="productDetails.productSafetyInformation"
      />
    </section>
    <section
      class="product-detailed-page__section product-detailed-page__accordion-padding"
      id="seoTable"
    >
      <product-items-table :itemInfoMap="productDetails.itemsWithInfo" />
    </section>

    <section
      class="product-detailed-page__section"
      id="shipping"
    >
      <product-additional-information />
    </section>

  </div>
</template>
<script>
import ProductPagePagination from '../productPagePagination/productPagePagination.vue'
import ProductPageBrand from '../productPageBrand/productPageBrand.vue'
import ProductGallery from '../productGallery/productGallery.vue'
import PhotoSwipeGallery from '../photoSwipeGallery/photoSwipeGallery.vue'
import ProductFlags from '../productFlags/productFlags.vue'
import SaleBox from '../saleBox/saleBox.vue'
import ProductNavigation from '../productNavigation/productNavigation.vue'
import ProductDescription from '../productDescription/productDescription.vue'
import ProductFeatures from '../productFeatures/productFeatures.vue'
import ProductSeobrand from '../productSeoBrand/productSeoBrand.vue'
import ProductAdditionalInformation from '../productAdditionalInformation/productAdditionalInformation.vue'
import RecommendationsTeaser from '../recommendationsTeaser/recommendationsTeaser.vue'
import Accordion from '../accordion/accordion.vue'
import ProductItemsTable from '../productItemsTable/ProductItemsTable.vue'
import ProductSafetyInformationAccordion from '../productSafetyInformationAccordion/ProductSafetyInformationAccordion.vue'

import dataLayerMixin from '../../utilities/vueMixins/dataLayerMixin/dataLayerMixin'
import productPageStateComputedMixin
  from '../../utilities/vueMixins/productPageStateComputedMixin/productPageStateComputedMixin'
import ScrollToElement from '../../utilities/js/scrollToElement/scrollToElement'

export default {
  components: {
    Accordion,
    ProductPagePagination,
    ProductPageBrand,
    ProductGallery,
    PhotoSwipeGallery,
    ProductFlags,
    SaleBox,
    ProductNavigation,
    ProductDescription,
    ProductFeatures,
    ProductSeobrand,
    ProductAdditionalInformation,
    RecommendationsTeaser,
    ProductItemsTable,
    ProductSafetyInformationAccordion
  },
  mixins: [
    dataLayerMixin,
    productPageStateComputedMixin,
  ],
  data() {
    return {
      isHash: '',
      productSafetyInformationHasData: false
    }
  },
  computed: {
    listSellingPoints() {
      if (this.sellingPoints.length) {
        return this.sellingPoints.slice(0, 5)
      }
    },
  },
  mounted() {
    this.productSafetyInformationHasData = this.productDetails.productSafetyInformation.safetyNotice
      || this.productDetails.productSafetyInformation.manufacturerDetails.length
      || this.productDetails.productSafetyInformation.responsiblePersonDetails.length
  },
  created() {
    let url = window.location.href
    let itemId = decodeURIComponent(window.location.href.split('itemId=')[1])
    if (itemId.indexOf('&') !== -1) {
      let toModifyHash = url
      itemId = itemId.split('&')[0]
      const utmParams = toModifyHash.split(`itemId=${itemId}&`)[1]
      window.location = url.split('#')[0] + utmParams + '#itemId=' + itemId
    }
    this.isHash = itemId !== 'undefined' ? itemId : this.productDetails.product.itemId
    if (this.isHash) {
      let initialOptions = {
        itemId: this.isHash,
        previousId: this.productDetails.product.itemId,
        quantity: this.productDetails.product.selectedQuantity,
        ajax: true
      }
      this.$store.dispatch('productPage/productUpdateFromHash', {
        formData: initialOptions,
        url: this.adsHashForwardPath
      })
    }
  },
  methods: {
    productNavigationClickHandler(id) {
      const section = this.$el.querySelector(`#${id}`)
      const sectionAccordion = this.$refs[`${id}-accordion`]

      if (sectionAccordion) {
        if (id === 'details-and-features') {
          this.$refs.accordion.open()
        } else {
          sectionAccordion.openAccordion()
        }
      }

      ScrollToElement(section)
    }
  },
}

</script>
